import { FC } from "react";
import { Decimal, Fiat, IconDenom } from "rujira.ui";
import { PositionBorrowRowFragment$data } from "./__generated__/PositionBorrowRowFragment.graphql";

export const PostitionRowCollateral: FC<
  PositionBorrowRowFragment$data["collaterals"][0]
> = (val) => {
  switch (val.collateral.__typename) {
    case "Balance":
      return (
        <div className="flex ai-c">
          <IconDenom
            denom={val.collateral.asset.metadata.symbol}
            className="w-4 mr-1"
          />
          <div className="flex dir-c">
            <Decimal
              amount={BigInt(val.collateral.amount)}
              symbol={val.collateral.asset.metadata.symbol}
              className="fs-16 condensed fw-500"
              clip
            />
            <Fiat
              amount={val.valueFull}
              symbol="$"
              className="color-grey fs-14 condensed"
              decimals={8}
              clip
            />
          </div>
        </div>
      );

    default:
      return null;
  }
};

export const PostitionRowDebt: FC<
  PositionBorrowRowFragment$data["debts"][0]
> = (val) => {
  return (
    <div className="flex ai-c">
      <IconDenom
        denom={val.debt.borrower.asset.metadata.symbol}
        className="w-4 mr-1"
      />
      <div className="flex dir-c">
        <Fiat
          amount={val.value}
          symbol="$"
          className="fs-16"
          decimals={8}
          clip
        />
        <Decimal
          amount={BigInt(val.debt.current)}
          symbol={val.debt.borrower.asset.metadata.symbol}
          className="color-grey fs-14 condensed fw-500"
          clip
        />
      </div>
    </div>
  );
};
